import React from 'react';

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  hint?: string;
  icon: string;
  accent?: 'blue' | 'green' | 'amber' | 'red' | 'cyan' | 'violet' | 'slate';
}

const accentClasses: Record<NonNullable<MetricCardProps['accent']>, string> = {
  blue: 'bg-blue-50 text-blue-600',
  green: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  red: 'bg-rose-50 text-rose-600',
  cyan: 'bg-cyan-50 text-cyan-600',
  violet: 'bg-violet-50 text-violet-600',
  slate: 'bg-slate-100 text-slate-700',
};

const MetricCard: React.FC<MetricCardProps> = ({ label, value, hint, icon, accent = 'blue' }) => {
  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-lg">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-semibold text-gray-600">{label}</p>
          <div className="mt-2 text-3xl font-black text-gray-900">{value}</div>
          {hint ? <p className="mt-2 text-sm text-gray-500">{hint}</p> : null}
        </div>
        <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${accentClasses[accent]}`}>
          <i className={`${icon} text-xl`}></i>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
